<div class="sidenav_container" [@onSideNavChange]="sideNavState ? 'open' : 'close'">
  <div fxLayout="column" fxLayoutGap="10px" style="height: 100vh;">

    <mat-toolbar class="logo-container">
      <img src="../../../assets/icons/icon-72x72.png" alt="" *ngIf="!sideNavState" class="close-icon"
        [@animateText]="!linkText ? 'show' : 'hide'" />
      <img src="../../../assets/icons/logo.png" alt="" *ngIf="sideNavState" class="open-icon"
        [@animateText]="linkText ? 'show' : 'hide'" />
    </mat-toolbar>
    <div class="photo-container">
      <!--div class="profile-photo">
        <mat-icon>person_outline</mat-icon>
      </div-->
      <p>{{user && user.name ? user.name:''}}</p>
      <p><strong>{{mainOrganization && mainOrganization.name ? mainOrganization.name:''}}</strong></p>
    </div>
    <div>
      <mat-nav-list>
        <mat-list-item *ngFor="let page of pages">
          <a mat-flat-button routerLink="{{ page.link }}" routerLinkActive="active" color="primary"
            class="button-menu-item"
            [ngClass]="{'opened': sideNavState,'button-menu-item-admin': page.name === 'SIDENAV.MENU.ACTIVITY_COPY' || page.name === 'SIDENAV.MENU.ORG_ACTIVITIES'|| page.name === 'SIDENAV.MENU.USERS'}"
            (click)="!showLogo ? sidenav.toggle():null">
            <mat-icon>{{page.icon}}</mat-icon>
            <span [@animateText]="sideNavState ? 'show' : 'hide'" style="margin-left:10px;">{{ page.name | translate
              }}</span>
          </a>
        </mat-list-item>
        <mat-list-item>
          <div>
            <a mat-flat-button href="https://app.box.com/s/x5rqyhzg7nzy9jyjmxrkmvzfhaglpm19" target="_blank" 
              color="primary" class="button-menu-item-complement" ><mat-icon>inbox</mat-icon>{{ 'SIDENAV.MENU.COMPLEMENTARY_FILES' | translate
              }}
            
            </a>
          </div>
        </mat-list-item>
        <mat-list-item *ngFor="let page2 of pages2">
          <a mat-flat-button routerLink="{{ page2.link }}" routerLinkActive="active" color="primary"
            class="button-menu-item"
            [ngClass]="{'opened': sideNavState,'button-menu-item-admin': page2.name === 'SIDENAV.MENU.ACTIVITY_COPY' || page2.name === 'SIDENAV.MENU.ORG_ACTIVITIES'|| page2.name === 'SIDENAV.MENU.USERS'}"
            (click)="!showLogo ? sidenav.toggle():null">
            <mat-icon>{{page2.icon}}</mat-icon>
            <span [@animateText]="sideNavState ? 'show' : 'hide'" style="margin-left:10px;">{{ page2.name | translate
              }}</span>
          </a>
        </mat-list-item>
      </mat-nav-list>


    </div>
    <div class="power-button">
      <a mat-fab color="accent" routerLink="auth/login" (click)="logout()">
        <mat-icon>power_settings_new</mat-icon>
      </a>
    </div>
    <mat-divider></mat-divider>
    <span fxFlex></span>
    <!-- <div fxLayout="row" fxLayoutAlign="center" style="padding: 0px 0px;">
    <a href="https://www.youtube.com/@simarobot1927/videos" title="youtube icons" target="_blank"><img src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_youtube-512.png" style="width:40px; height:40px;"></a> -->
    <!-- <div>
      <mat-list>
        <mat-list-item class="category-item" *ngFor="let category of categories">
          <mat-icon [color]="category.color">{{ category.icon }}</mat-icon>
          <span [@animateText]="sideNavState ? 'show' : 'hide'" style="margin-left:10px;">{{ category.name | translate }}</span>
        </mat-list-item>
      </mat-list>
    </div> -->
<!--     
    <a href="https://api.whatsapp.com/send?phone=56940113411" title="youtube icons" target="_blank"><img src="http://atacamahostel.cl/wp-content/uploads/2019/11/whatsapp-icon-transparent-png-7.png" style="width:39px; height:39px;" ></a>
  </div> -->
    <span fxFlex></span>
    <mat-divider></mat-divider>
    <div fxLayout="row" fxLayoutAlign="end center" style="padding: 0px 0px;">
      <button mat-icon-button [matMenuTriggerFor]="languages">
        <mat-icon>translate</mat-icon>
      </button>
      <mat-menu #languages="matMenu">
        <button mat-menu-item (click)="setLanguages('es')">{{ 'LANG.SPANISH' | translate }}</button>
        <button mat-menu-item (click)="setLanguages('en')">{{ 'LANG.ENGLISH' | translate }}</button>
      </mat-menu>
      
      <span fxFlex></span>
      <button mat-icon-button (click)="onSidenavToggle()">
        <mat-icon *ngIf="sideNavState">menu_open</mat-icon>
        <mat-icon *ngIf="!sideNavState">double_arrow</mat-icon>
      </button>
    </div>
  </div>
</div>